import { render, staticRenderFns } from "./Summary_ToothTreatments.vue?vue&type=template&id=5ec9b108&scoped=true&"
import script from "./Summary_ToothTreatments.vue?vue&type=script&lang=js&"
export * from "./Summary_ToothTreatments.vue?vue&type=script&lang=js&"
import style0 from "./Summary_ToothTreatments.vue?vue&type=style&index=0&id=5ec9b108&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec9b108",
  null
  
)

export default component.exports